import createVueComponent from '../createVueComponent';

const CircleSlashed = createVueComponent('CircleSlashedIcon', [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['path', { d: 'M22 2L2 22' }],
]);

export default CircleSlashed;
